import { Search, X } from 'lucide-react';
import React, { useEffect, useState } from 'react'

function SearchView({ className, placeholder, onSearch, debounceTime }) {
    const [search_text, setSearchText] = useState("");

    useEffect(() => {
        var timer = setTimeout(
            () => {
                onSearch(search_text)
            },
            debounceTime || 300
        )
        return () => clearTimeout(timer);
    }, [search_text])

    return <div className={`tw-border tw-rounded-md tw-text-sm tw-px-3 tw-py-2 tw-flex tw-items-center ${className}`}>
        <Search className='tw-text-gray-400' size={18} />
        <input className='tw-outline-0 tw-ml-3 tw-text-sm tw-w-full tw-bg-transparent focus:tw-outline-none focus:tw-ring-0 focus-visible:tw-outline-none focus-visible:tw-ring-0'
            value={search_text}
            placeholder={placeholder || "Search"}
            onChange={(evt) => {
                setSearchText(evt.target.value);
            }}
        />
        {
            search_text
                ? <X className='tw-ml-auto tw-text-gray-600' size={18} onClick={() => setSearchText("")} />
                : null
        }
    </div>
}

export { SearchView }